import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { DEFAULT_CLUSTER_LIMIT, DEFAULT_HISTORY_LIMIT, TRADING_FEED_POLL_MS } from "./constants";

export function useTradingFeed(materialId: string, historyLimit = DEFAULT_HISTORY_LIMIT) {
  return useQuery({
    queryKey: ["trading-feed", materialId, historyLimit],
    queryFn: () =>
      api.getTradingFeed(materialId, {
        historyLimit,
        clusterLimit: DEFAULT_CLUSTER_LIMIT,
      }),
    enabled: Boolean(materialId),
    refetchInterval: TRADING_FEED_POLL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
}
